/** AppRoute `category/:id` — SEO Helmet 대상 슬러그 */
export const CATEGORY_SEO_SLUGS = [
  'sleep',
  'concentration',
  'stress',
  'minit_miracle',
  'experience',
  'diet',
] as const;

export type CategorySeoSlug = (typeof CATEGORY_SEO_SLUGS)[number];

export function isCategorySeoSlug(id: string | undefined): id is CategorySeoSlug {
  return CATEGORY_SEO_SLUGS.includes(id as CategorySeoSlug);
}

export const SITE_ORIGIN = 'https://soundpill.app';
